export interface ErrorEntry {
  path: (string | number)[];
  code: string;
  message: string;
  context?: Record<string, unknown>;
}

export interface AppErrorDetails {
  cause?: unknown;
  code?: string;
  details?: ErrorEntry[];
}

export class AppException extends Error {
  readonly code?: string;
  readonly details?: ErrorEntry[];

  constructor(message: string, errorDetails?: AppErrorDetails) {
    super(message);
    this.name = this.constructor.name;
    this.code = errorDetails?.code;
    this.details = errorDetails?.details;

    // Create a stack property on this class for tracing
    /*
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
        }*/

    // Set the cause if provided
    if (errorDetails?.cause) {
      this.cause = errorDetails.cause;
    }
  }
}
